module.exports = "data:image/svg+xml;base64,PHN2ZwogIGZpbGw9Im5vbmUiCiAgaGVpZ2h0PSIxOCIKICB2aWV3Qm94PSIwIDAgMTggMTgiCiAgd2lkdGg9IjE4IgogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKPgogIDxjaXJjbGUgY3g9IjkiIGN5PSI5IiBmaWxsPSIjQzRDNEM0IiBvcGFjaXR5PSIwLjUiIHI9IjkiLz4KICA8cGF0aAogICAgZD0iTTEyIDhMOSAxMUw2IDgiCiAgICBzdHJva2U9IiM2QzZDNkMiCiAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIgogICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./static/appicons/Chevron.svg
// module id = 1071
// module chunks = 0